const getBankAccounts = () => {
    const bankAccounts = localStorage.getItem("bankAccounts")
        ? JSON.parse(localStorage.getItem("bankAccounts"))
        : null;

    return bankAccounts;
};

const InitialState = {
    bankAccounts: getBankAccounts(),
};

const BankAccountsReducer = (state = InitialState, action) => {
    if (action.type === "Save_Bank_Accounts") {
        const newState = {
            ...state,
            bankAccounts: action.payload,
        };
        localStorage.setItem("bankAccounts", JSON.stringify(action.payload));
        return newState;
    }

    else if (action.type === "Remove_User") {
        localStorage.removeItem("bankAccounts");
        const newState = {
            bankAccounts: null
        };
        return newState;
    }

    return state;
};

export default BankAccountsReducer;